import { Link } from 'react-router-dom';
import { ArrowUpRight } from '@phosphor-icons/react';
import { PageHero, Reveal } from '../../lib/motion';
import { inputCls } from '../site/FormBits';

export { inputCls };

export const statusLabel = (status) => String(status || 'new').replace(/_/g, ' ');

export const StatusPill = ({ status }) => {
  const hot = ['accepted', 'awarded', 'completed', 'verified', 'approved'].includes(status);
  const warn = ['founder_review', 'matching', 'quotes_received', 'pending', 'submitted'].includes(status);
  return (
    <span className={`inline-flex border px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.15em] ${hot ? 'border-volt/50 bg-volt/10 text-volt' : warn ? 'border-steel/40 bg-steel/10 text-steel' : 'border-line text-steel'}`} data-testid={`status-${status || 'new'}`}>
      {statusLabel(status)}
    </span>
  );
};

export const DashboardShell = ({ eyebrow, title, sub, children, actions }) => (
  <div data-testid={`${eyebrow.toLowerCase().replace(/\s+/g, '-')}-shell`}>
    <PageHero eyebrow={eyebrow} lines={[title]} sub={sub} />
    <section className="bg-ink bg-grid">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-10 lg:py-20">
        {actions && <div className="mb-8 flex flex-wrap gap-3">{actions}</div>}
        {children}
      </div>
    </section>
  </div>
);

export const StatCard = ({ label, value, testId }) => (
  <div className="border border-line bg-surface p-6" data-testid={testId}>
    <p className="mono-label text-steel">{label}</p>
    <p className="mt-3 font-display text-3xl font-black text-parchment">{value}</p>
  </div>
);

export const EmptyState = ({ title, text, actionLabel, actionTo, testId }) => (
  <div className="border border-line bg-surface p-10 text-center" data-testid={testId}>
    <p className="font-display text-2xl font-black text-parchment">{title}</p>
    <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-steel">{text}</p>
    {actionTo && (
      <Link to={actionTo} className="mt-6 inline-flex items-center gap-2 bg-volt px-5 py-3 font-mono text-xs font-bold uppercase tracking-[0.15em] text-ink transition-transform duration-200 hover:-translate-y-0.5">
        {actionLabel} <ArrowUpRight size={14} weight="bold" />
      </Link>
    )}
  </div>
);

export const Panel = ({ title, children, testId, className = '', id }) => (
  <Reveal className={className}>
    <div id={id} className="border border-line bg-surface p-6 sm:p-8" data-testid={testId}>
      {title && <h2 className="mb-5 font-display text-xl font-black text-parchment">{title}</h2>}
      {children}
    </div>
  </Reveal>
);

export const formatDate = (value) => {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleDateString('en-SG', { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return value;
  }
};
